import React, { useState, useEffect } from 'react'

// Time in milliseconds that the fade-out effect will take
const FADE_OUT_TIME = 100

export const SplashScreen = () => {
  const params = new URLSearchParams(globalThis.location.search)
  const isSuppressed =
    params.get('splash') === 'false' || params.get('webview') === 'true'
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    if (isSuppressed) return
    const timer = setTimeout(() => setVisible(false), FADE_OUT_TIME)
    return () => clearTimeout(timer)
  }, [isSuppressed])

  if (isSuppressed) return null

  return (
    <div
      className="w-full h-full color-bgPrimary absolute z-10 pointer-events-none transition-opacity duration-300"
      style={{ opacity: visible ? 1 : 0 }}
    />
  )
}
